import request from '../utils/request';

export const fetchUsersAPI = async (usersInitials: string) => {
    const results = await request.get(
        `/users/search?initials=${usersInitials}`
    );
    return results.data;
};

export const fetchUserDetailsAPI = async (userId: string) => {
    const details = await request.get(`/users/${userId}/details`);
    return details.data;
};

export const fetchUserStatsAPI = async (userId: string) => {
    const details = await request.get(`/users/${userId}/stats`);
    return details.data;
};

export const fetchUserHistoryAPI = async (userId: string, limit: number) => {
    const details = await request.get(
        `/users/${userId}/history?limit=${limit}`
    );
    return details.data;
};

export const fetchNextEvents = async () => {
    const nextEvents = await request.get(`/users/next-events`);
    return nextEvents.data;
};

export const followUserAPI = async (userId: string) => {
    const details = await request.post(`/users/${userId}/followers`);
    return details.data;
};

export const fetchUserFollowersAPI = async (userId: string) => {
    const details = await request.get(`/users/${userId}/followers`);
    return details.data;
};
